export const VISIBILITY_EXPRESSION_PROPERTY_NAME: string = 'Visibility Expression';
export const VALIDATION_EXPRESSION_PROPERTY_NAME: string = 'Validation expression';


// WEBPACK FOOTER //
// ./source/ts/constants/property.ts